<!--全部订单  -->
<template>
  <div class="allIndent">
    <div class="allIndent-body">
      <HandselEntrance ref="Handsel" />
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          :offset="20"
          v-if="isData"
          @load="onLoad"
        >
          <div class="card" v-for="(item, index) in orderList" :key="index">
            <div class="invoice" v-if="showInvoice === index" @click="jumpInvoice(item)">
              {{ showStatus(item) }}
            </div>

            <div class="card-header">
              <div class="card-header-first">
                <div :class="item.status == 1 ? 'left await' : 'left'">
                  {{ filtersStatus(item.status) }}
                </div>
                <div class="right" v-if="item.status == 1 && item.countDown">
                  <span class="count">{{ item.countDown }}</span>
                  <span>后自动取消</span>
                </div>
                <div class="right" v-if="item.status == 4 || item.status == 5">
                  <span class="count">{{
                    item.cancelType == 1
                      ? '超时未支付'
                      : item.cancelType == 2
                      ? '主动取消'
                      : '客服取消'
                  }}</span>
                </div>
                <!-- 已完的订单，canApplyInvoice 可以申请开票， -->
                <img
                  class="dot"
                  v-if="item.status == 3 && (item.invoiceStatus || item.canApplyInvoice)"
                  @click="change(index)"
                  src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invoice/dot.png"
                  alt=""
                />
              </div>
              <div
                class="hint"
                v-if="item.status == 3 && item.needAddress == 1 && item.bindAddress == false"
              >
                <span class="text">该订单含有配套资料，为了方便给你发货，请添加收货地址</span>
              </div>
            </div>
            <div class="card-body" @click="courseDetails(item.orderNo)">
              <div
                class="public"
                v-for="(course, index) in item.orderPackageProductRespList || item.orderProductList"
                :key="index"
              >
                <div class="text">
                  <p class="name">
                    <i
                      v-if="course.productName.substr(0, 1) == '【'"
                      class="title-special-processing"
                    />{{ course.productName }}
                  </p>
                </div>
                <span class="pice">￥{{ course.productPrice }}</span>
              </div>
              <!-- 订单的赠品，增值，协议，本期没有这需求，所以注释了 -->
              <!-- <div class="public">
              <div class="text">
                <span>协议</span>
                <p class="deal">
                考研直播课程名称考研直播程名称考研直播课程名称考研直播程名称
                </p>
              </div>
              <span class="pice">￥2000</span>
            </div>
            <div class="public">
            <div class="text">
              <span>增值</span>
              <p class="deal">
                考研直播课程名称考研直播程名称考研直播课程名称考研直播程名称
                </p>
              </div>
            <span class="pice">￥2000</span>
          </div> -->
            </div>
            <div class="card-footer">
              <div class="pay">
                <span>下单时间 {{ item.createTime }}</span>
                <div class="money">
                  <span>
                    <p>{{ filtersPayText(item.status) }}</p>
                    <p class="pice">￥{{ item.channel == 45 ? 0 :item.partnerOrder?item.orderTotalAmount: item.orderAmount }}</p>
                  </span>
                  <!-- <span><p>应付</p><p class="pice">￥1000</p></span> -->
                </div>
              </div>
              <div class="button">
                <div class="cancel" v-if="item.status == 1" @click="cancelOrder(item.orderNo)">
                  取消订单
                </div>
                <div class="payment" v-if="item.status == 1" @click="payOrder(item.orderNo)">
                  立即支付
                </div>

                <div
                  class="add-address"
                  v-if="item.status == 3 && item.needAddress == 1 && item.bindAddress == false"
                  @click="addAddress(item.orderNo)"
                >
                  添加地址
                </div>
                <div
                  v-else-if="item.status == 3 && item.needAddress == 1 && item.bindAddress == true"
                  class="add-address"
                  @click="shippedOrder(item.orderNo)"
                >
                  发货信息
                </div>
              </div>
            </div>
          </div>
        </van-list>
        <EmptyData :emptyName="'noIndent'" v-else />
      </van-pull-refresh>
    </div>
    <DiaLog ref="logShow" :logType="'allIndent'" :orderID="orderID" @clearAllList="clearAllList" />
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { invalidTimeCount } from '@/utils/tools';
import { reqOrderList } from '@/api/personal/orderController';
import EmptyData from '@/components/emptyData/emptyData.vue';
import DiaLog from '../components/diaLog.vue';
import { orderType, selectPayText } from '../indentTools';
import { isLogin } from '@/utils/common';
import HandselEntrance from '../components/handselEntrance.vue';

export default {
  data() {
    return {
      add: false,
      scroll: null,
      orderParam: {
        pageNum: 1,
        pageSize: 5,
        status: '',
      },
      finished: false,
      loading: true,
      refreshing: false,
      orderList: [], // 订单列表
      isData: true,
      orderTotal: 0, // 订单总数
      timer: null, // 定时器
      logShow: false, // 提示框
      orderID: '', // 取消订单时id
      showInvoice: -1,
    };
  },

  components: {
    EmptyData,
    DiaLog,
    HandselEntrance,
  },

  computed: {},

  mounted() {},

  created() {
    if (isLogin()) {
      this.getOrderList(this.orderParam);
    }
  },

  methods: {
    // 每次向下滚动，滚动条与底部距离小于offset时触发
    onLoad() {
      if (this.orderList.length >= this.orderTotal) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished = true;
      } else {
        // 如果发现现有数组并没有达到总条数则加页继续发送请求
        clearInterval(this.timer);
        this.timer = null;
        this.orderParam.pageNum += 1;
        this.getOrderList(this.orderParam);
      }
    },
    // 下拉刷新
    onRefresh() {
      this.refreshing = true;
      this.clearOrderList();
      this.$refs.Handsel.getHandsel();
    },
    // 清除缓存重新请求
    clearOrderList() {
      this.orderParam.pageNum = 1;
      this.loading = false;
      this.finished = false;
      this.orderList = [];
      this.getOrderList(this.orderParam);
    },
    // 获取订单列表
    async getOrderList(data) {
      try {
        const res = await reqOrderList(data);
        if (res.code === 0) {
          clearInterval(this.timer);
          if (res.data.total === 0) {
            this.isData = false;
          }
          if (this.refreshing) {
            this.orderList = [];
          }
          this.refreshing = false;
          res.data.data.forEach((item) => {
            const { orderPackageProductRespList } = item;
            (orderPackageProductRespList || []).forEach((child) => {
              Object.assign(child, { productName: child.packageName, productPrice: child.price });
            });
          });
          this.orderList.push(...res.data.data);
          this.orderTotal = res.data.total;
          this.loading = false;
          this.transferTimeList(this.orderList); // 执行倒计时
        } else {
          this.$toast(`请求异常！${res.msg}`);
        }
      } catch (error) {
        this.$toast(error.message);
      }
    },
    // 等待支付倒计时
    transferTimeList(list) {
      const that = this;
      this.timer = setInterval(() => {
        list.forEach((item) => {
          const Obj = item;
          // 只有待支付状态有倒计时
          if (Obj.status === 1 && Obj.payTimeout !== 0) {
            // 倒计时为0刷新数据
            if (Obj.payTimeout === 0) {
              clearInterval(that.timer);
              this.clearOrderList();
            }
            Obj.payTimeout -= 1;
            Obj.countDown = invalidTimeCount(Obj.payTimeout);
            that.$set(that.orderList, Obj.countDown, invalidTimeCount(Obj.payTimeout));
          }
        });
      }, 1000);
    },
    // 订单状态
    filtersStatus(status) {
      return orderType(status);
    },
    filtersPayText(status) {
      return selectPayText(status);
    },
    // 进入详情页
    courseDetails(orderNo) {
      this.$router.push({ path: '/indentDetail', query: { orderNo } });
    },
    // 取消订单
    cancelOrder(id) {
      this.$refs.logShow.show = true;
      this.orderID = id;
    },
    // 取消弹窗确认取消重新请求数据
    clearAllList() {
      this.clearOrderList();
    },
    // 立即支付
    payOrder(orderNumber) {
      if (this.$root.$data.isApp) {
        this.$sendToApp('payCenter', { orderNo: orderNumber }, false);
        return;
      }
      if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/myCourse/cashier/cashier?orderNo=${orderNumber}`,
        });
        return;
      }
      this.$router.push({
        path: '/cashier',
        query: {
          orderNo: orderNumber,
        },
      });
    },
    // 添加地址
    addAddress(orderNo) {
      this.$router.push({
        path: '/personalCenter/address',
        query: { orderNo, sourse: 1, isHideMask: true },
      });
    },
    // 发货信息
    shippedOrder() {
      this.$router.push({ path: 'myExpress' });
    },
    change(index) {
      this.showInvoice = index === this.showInvoice ? -1 : index;
    },
    jumpInvoice(data) {
      const { orderNo, invoiceStatus, canApplyInvoice } = data;
      if (canApplyInvoice) {
        this.$router.push({ path: '/invoiceIndex', query: { orderNo } });
      } else {
        this.$router.push({ path: '/invoiceDetail', query: { orderNo } });
      }
    },
    showStatus(data) {
      const { invoiceStatus, canApplyInvoice } = data;
      return canApplyInvoice
        ? '申请开票'
        : invoiceStatus === 1 || invoiceStatus === 2|| invoiceStatus === 3
        ? '查看发票'
        : '';
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },

  // activated(){
  //   if(!this.$route.meta.isUseCache){ //isUseCache 时添加中router中的元信息，判读是否要缓存
  //     this.contactList = [] //清空原有数据
  //     this.contactDisplay() // 重新加载
  //   }
  // }
};
</script>
<style lang="scss" scoped>
@import '@/style/indentCard.scss';

.allIndent {
  height: 100%;
}
</style>
